/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Collections_Meta_TitleInputs */

const id_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const ms_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const da_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const de_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const en_us2_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const es_es2_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const es_mx2_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const fil_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const fr_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const it_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const hu_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const nl_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const no_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const pl_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const pt_br2_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const pt_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const ro_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const fi_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const sv_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const vi_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const tr_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const cs_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const bg_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const ru_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const uk_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const ar_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const hi_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const th_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const ja_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const zh_cn2_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const zh_hant1_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

const ko_collections_meta_title = /** @type {(inputs: Collections_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} | egdata.app`)
};

/**
* | output |
* | --- |
* | "{title} \| egdata.app" |
*
* @param {Collections_Meta_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const collections_meta_title = /** @type {((inputs: Collections_Meta_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Collections_Meta_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_collections_meta_title(inputs)
	if (locale === "ms") return ms_collections_meta_title(inputs)
	if (locale === "da") return da_collections_meta_title(inputs)
	if (locale === "de") return de_collections_meta_title(inputs)
	if (locale === "en-US") return en_us2_collections_meta_title(inputs)
	if (locale === "es-ES") return es_es2_collections_meta_title(inputs)
	if (locale === "es-MX") return es_mx2_collections_meta_title(inputs)
	if (locale === "fil") return fil_collections_meta_title(inputs)
	if (locale === "fr") return fr_collections_meta_title(inputs)
	if (locale === "it") return it_collections_meta_title(inputs)
	if (locale === "hu") return hu_collections_meta_title(inputs)
	if (locale === "nl") return nl_collections_meta_title(inputs)
	if (locale === "no") return no_collections_meta_title(inputs)
	if (locale === "pl") return pl_collections_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_collections_meta_title(inputs)
	if (locale === "pt") return pt_collections_meta_title(inputs)
	if (locale === "ro") return ro_collections_meta_title(inputs)
	if (locale === "fi") return fi_collections_meta_title(inputs)
	if (locale === "sv") return sv_collections_meta_title(inputs)
	if (locale === "vi") return vi_collections_meta_title(inputs)
	if (locale === "tr") return tr_collections_meta_title(inputs)
	if (locale === "cs") return cs_collections_meta_title(inputs)
	if (locale === "bg") return bg_collections_meta_title(inputs)
	if (locale === "ru") return ru_collections_meta_title(inputs)
	if (locale === "uk") return uk_collections_meta_title(inputs)
	if (locale === "ar") return ar_collections_meta_title(inputs)
	if (locale === "hi") return hi_collections_meta_title(inputs)
	if (locale === "th") return th_collections_meta_title(inputs)
	if (locale === "ja") return ja_collections_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_collections_meta_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_collections_meta_title(inputs)
	return ko_collections_meta_title(inputs)
});
export { collections_meta_title as "collections.meta.title" }